import React from "react";

import { FormattedMessage } from "react-intl";

import { Text } from "@/components/atoms/Text";

import { TrustCard } from "./TrustSectionCard";
import { useTrustIntroBlockList } from "./useTrustIntroBlockList";

const TrustIntroBlock = () => {
  const items = useTrustIntroBlockList();

  return (
    <section className="ps-container-lg-margin ps-container-fixed tw-pb-32 lg:tw-pb-96 tw-relative tw-mt-auto">
      <div className="ps-row">
        <div className="col-xs-12">
          <div className="tw-flex tw-flex-col tw-gap-24">
            <div className="tw-flex tw-flex-col tw-gap-16">
              <div className="lg:tw-w-1/2">
                <Text
                  element="h2"
                  typeface="headline-5-m"
                  className="lg:tw-display-1-b tw-text-brand-white"
                >
                  <FormattedMessage defaultMessage="Host with confidence. We've got your back." />
                </Text>
              </div>
              <Text
                element="p"
                typeface="body-3"
                className="lg:tw-body-4 tw-text-brand-white"
              >
                <FormattedMessage defaultMessage="Every Peerspace booking includes industry-leading protection at no extra cost to you. Built into the platform." />
              </Text>
            </div>
            <div className="tw-grid tw-grid-cols-1 lg:tw-grid-cols-3 tw-gap-16 lg:tw-gap-32">
              {items.map(
                ({
                  id: trustIntroItemId,
                  trustIntroItemDescription,
                  trustIntroItemIcon,
                  trustIntroItemTitle,
                  trustIntroItemSubtitle,
                  trustIntroItemCaption,
                }) => (
                  <TrustCard
                    key={trustIntroItemId}
                    icon={trustIntroItemIcon}
                    title={trustIntroItemTitle}
                    subtitle={trustIntroItemSubtitle}
                    description={trustIntroItemDescription}
                    caption={trustIntroItemCaption}
                  />
                ),
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export { TrustIntroBlock };
